<template>
  <el-container>
    <el-aside width="211px">
      <div class="aside-head">字典列表</div>
      <div class="btn-labal">
        <el-radio v-model="dic_tab" label="1" @change="change_dic_tab"
          >私有字典</el-radio
        >
        <el-radio v-model="dic_tab" label="2" @change="change_dic_tab"
          >公有字典</el-radio
        >
      </div>
      <div class="aside-sea">
        <sw-search
          :simple="true"
          :placeholder="'请输入搜索内容'"
          @search="sea_type"
        />
      </div>
      <nav v-loading="!show_type_list">
        <ul v-if="type_list.length > 0">
          <li
            v-for="(type, index) in type_list"
            :class="{ 'em-choose': type_index === index }"
            :key="index"
            @click.stop="dic_type_choose(type, index)"
          >
            {{ type.type_name }}
          </li>
        </ul>
      </nav>
    </el-aside>
    <el-main>
      <router-link tag="span" to="/workbench" class="tdh-right"
        >返回</router-link
      >
      <div class="tdh-left">
        <span class="tdhl-rect-icon" />
        <router-link tag="span" to="/workbench" class="tdhl-title"
          >应用中心</router-link
        >
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle"
          ><span />{{ $route.query.name }}-相关字典</span
        >
      </div>
      <div class="action-label">
        <div class="btn-lab">
          <sw-button
            v-if="dic_tab == 1"
            :custom-button-size="9"
            type="primary"
            icon="su-icon-plus"
            @click.stop="open_add_dicPanel()"
            >新增字典项</sw-button
          >
          <sw-button
            v-if="dic_tab == 1"
            :custom-button-size="9"
            :disabled="select_arr.length === 0"
            icon="su-icon-delete"
            simple
            @click.stop="delete_dic()"
            >删除</sw-button
          >
        </div>
        <div v-if="show_search" class="sea-lab">
          <sw-input
            v-model.trim="keyword_list"
            placeholder="请输入字典值或字典代码"
            clearable
            class="input-with-select dic-input"
            @change="search_dic_list"
          >
            <el-button
              slot="append"
              style="margin: 0 !important"
              icon="el-icon-search"
              @click="search_dic_list"
            />
          </sw-input>
          <!-- <sw-search :placeholder="'请输入字典值或字典代码'" @search="search_dic_list"/> -->
          <sw-button
            :custom-button-size="8"
            type="primary"
            icon="su-icon-renew"
            @click.stop="clear_keyword()"
          />
        </div>
      </div>
      <div class="main-tab">
        <div v-show="dic_tab == 1">
          <sw-table
            v-loading="loading"
            :table-name="'dic-private'"
            :table-data="dic_private.tableData"
            :table-title="dic_private.tableTitle"
            :has-operation="true"
            :page-sizes="table_size"
            :total-count="total_count"
            :page-size="10"
            :table-operation="dic_private.tableOperation"
            :conflict-operation="dic_private.conflictOperation"
            @selection-change="select_change"
            @operation-handle="private_handle"
            @change-page="private_change_page"
            @size-change="private_size_change"
            @addHandle="open_add_dicPanel"
          />
        </div>
        <div v-show="dic_tab == 2">
          <sw-table
            :table-name="'dic-public'"
            :table-data="dic_public.tableData"
            :table-title="dic_public.tableTitle"
            :has-operation="false"
            :page-sizes="table_size"
            :total-count="total_count"
            :page-size="10"
            :show-selection="false"
            :has-add-button="false"
            @change-page="public_change_page"
            @size-change="public_size_change"
            @selection-change="select_change"
          >
            <template slot="customcolumn" slot-scope="scope">
              <span
                v-if="scope.item.prop == 'enable'"
                :class="
                  scope.row.enable === 1
                    ? 'sw-table-active'
                    : 'sw-table-inactive'
                "
              >
                {{ scope.row.zt === 1 ? "已开启" : "已关闭" }}
              </span>
              <span
                v-else
                :title="
                  scope.row[scope.item.prop] ? scope.row[scope.item.prop] : '-'
                "
                class="swTableCell"
              >
                {{
                  scope.row[scope.item.prop] ? scope.row[scope.item.prop] : "-"
                }}
              </span>
            </template>
          </sw-table>
        </div>
      </div>
    </el-main>
    <sw-slide-dialog
      :visible.sync="show_add_dic"
      :width="'648px'"
      title="新增字典项"
    >
      <el-form
        ref="new_dic_data"
        :model="new_dic_data"
        :rules="rules"
        :sw-validator="true"
        status-icon
        label-width="120px"
      >
        <el-form-item label="字典类型：" label-width="120px" prop="type_name">
          <el-input
            v-model.trim="new_dic_data.type_name"
            placeholder="请输入字典类型"
            autocomplete="type_name"
          />
        </el-form-item>
        <el-form-item label="类型代码：" label-width="120px" prop="type_code">
          <el-input
            v-model.trim="new_dic_data.type_code"
            placeholder="请输入类型代码"
            autocomplete="type_code"
          />
        </el-form-item>
        <el-form-item label="字典代码：" label-width="120px" prop="key_code">
          <el-input
            v-model.trim="new_dic_data.key_code"
            placeholder="请输入字典代码"
            @keyup="
              edit_dic_data.key_code = edit_dic_data.key_code.replace(
                /[\u4E00-\u9FA5]/g,
                ''
              )
            "
          />
        </el-form-item>
        <el-form-item label="字典值：" label-width="120px" prop="value_name">
          <el-input
            v-model.trim="new_dic_data.value_name"
            placeholder="请输入字典值"
          />
        </el-form-item>
        <el-form-item label="描述：" label-width="120px" prop="description">
          <el-input
            v-model.trim="new_dic_data.description"
            placeholder="请输入字典值描述"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <sw-button :custom-button-size="9" @click="show_add_dic = !show_add_dic"
          >取 消</sw-button
        >
        <sw-button
          :loading="btn_loading"
          :custom-button-size="9"
          type="primary"
          @click="add_new_dic"
          >确 定</sw-button
        >
      </span>
    </sw-slide-dialog>
    <sw-dialog
      :visible.sync="dic_private.show_edit_panel"
      :width="'30%'"
      center
      append-to-body
      title="字典修改"
    >
      <el-form
        ref="edit_dic_data"
        :model="edit_dic_data"
        :rules="rules"
        :sw-validator="true"
        status-icon
        label-width="200px"
      >
        <el-form-item label="字典类型：" label-width="100px" prop="type_name">
          <el-input
            v-model.trim="edit_dic_data.type_name"
            disabled
            placeholder="请输入字典类型"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="类型代码：" label-width="100px" prop="type_code">
          <el-input
            v-model.trim="edit_dic_data.type_code"
            disabled
            placeholder="请输入类型代码"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item label="字典代码：" label-width="100px" prop="key_code">
          <el-input
            v-model.trim="edit_dic_data.key_code"
            placeholder="请输入字典代码"
          />
        </el-form-item>
        <el-form-item label="字典值：" label-width="100px" prop="value_name">
          <el-input
            v-model.trim="edit_dic_data.value_name"
            placeholder="请输入字典值"
          />
        </el-form-item>
        <el-form-item label="描述：" label-width="100px" prop="description">
          <el-input
            v-model.trim="edit_dic_data.description"
            placeholder="请输入字典值描述"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <div>
          <sw-button
            :loading="btn_loading"
            :custom-button-size="9"
            type="primary"
            @click.stop="edit_dic"
            >更 新</sw-button
          >
          <sw-button
            :custom-button-size="9"
            simple
            @click.stop="
              dic_private.show_edit_panel = !dic_private.show_edit_panel
            "
            >取 消</sw-button
          >
        </div>
      </div>
    </sw-dialog>
  </el-container>
</template>
<script>
import service from "@/utils/service";
export default {
  data() {
    return {
      dic_tab: "1", // 1私有2共有
      type_list: [], // 字典类型数组
      type_list_copy: [], // 保存类型列表
      type_index: 0, // 当前选中的字典类型下标
      show_add_dic: false,
      show_type_list: false,
      show_search: false,
      new_dic_data: {
        type_name: "",
        type_code: "",
        key_code: "",
        value_name: "",
        description: "",
      },
      edit_dic_data: {},
      rules: {},
      select_arr: [],
      dic_private: { show_edit_panel: false },
      dic_public: {},
      limit: 10,
      keyword_list: "",
      ct: null, // 防抖
      show_dic_tab: false,
      total_count: 0,
      data: {},

      keyword_serch: "",
      loading: false,
      btn_loading: false,
    };
  },
  computed: {
    table_size() {
      return this.$store.state.app.tableSize;
    },
  },
  created() {
    this.rules = {
      type_name: [
        { required: true, message: "请输入字典类型", trigger: "blur" },
      ],
      type_code: [
        { required: true, message: "请输入类型代码", trigger: "blur" },
      ],
      key_code: [
        { required: true, message: "请输入字典代码", trigger: "blur" },
      ],
      value_name: [
        { required: true, message: "请输入字典值", trigger: "blur" },
      ],
      description: [
        { required: true, message: "请输入字典值描述", trigger: "blur" },
      ],
      // range: [
      //   { required: true, message: '请选择范围', trigger: 'blur' }
      // ]
    };
    this.change_dic_tab("1");
    this.dic_private_init();
    this.dic_public_init();
  },
  methods: {
    // 私有字典表格初始化
    dic_private_init() {
      // 表头
      this.$set(this.dic_private, "tableTitle", [
        { prop: "type_name", label: "字典类型", width: "190", sortable: true },
        { prop: "type_code", label: "类型代码", width: "260", sortable: true },
        { prop: "key_code", label: "字典代码", width: "250", sortable: true },
        { prop: "value_name", label: "字典值", width: "190", sortable: true },
      ]);
      this.$set(this.dic_private, "tableData", []);

      // 操作
      this.$set(this.dic_private, "tableOperation", [
        { name: "编辑", icon: "su-icon-edit", operation: "edit" },
        { name: "删除", icon: "su-icon-delete", operation: "delete" },
      ]);
      // tab2操作项冲突解决
      this.$set(this.dic_private, "conflictOperation", {
        // edit:{prop:'zt',value:[0]},
        // pause:{prop:'zt',value:[3]}
      });
    },
    // 共有字典表格初始化
    dic_public_init() {
      this.$set(this.dic_public, "tableTitle", [
        { prop: "key_code", label: "字典代码", width: "250", sortable: true },
        { prop: "value_name", label: "字典值", width: "190", sortable: true },
        { prop: "description", label: "描述", width: "190", sortable: false },
        { prop: "enable", label: "是否启用", width: "175", sortable: true },
      ]);
      this.$set(this.dic_public, "tableData", [
        { id: 0, value_name: "张三", key_code: "100分钟", describe: "111" },
      ]);
    },
    // 字典类型选择
    dic_type_choose(type, index) {
      this.$set(this.dic_private, "tableData", []);
      this.$set(this.dic_public, "tableData", []);
      this.show_search = false;
      this.keyword_list = "";
      this.type_index = index;
      this.get_dic_list(type, 1);
    },
    async change_dic_tab(str) {
      this.limit = this.table_size[0];
      this.dic_tab = str;
      this.type_list = [];
      this.type_index = 0;
      this.show_search = false;
      this.keyword_list = "";
      this.$set(this.dic_private, "tableData", []);
      this.$set(this.dic_public, "tableData", []);
      await this.get_dic_type_list();
    },
    // 搜索字典值列表
    search_dic_list() {
      this.get_dic_list(this.type_list[this.type_index], 1);
    },
    clear_keyword() {
      this.keyword_list = "";
      this.show_search = false;
      this.show_dic_tab = false;
      this.get_dic_list(this.type_list[this.type_index], 1);
    },
    // 打开新增字典页面
    open_add_dicPanel() {
      if (this.type_list && this.type_list.length > 0) {
        this.new_dic_data.type_name = this.type_list[this.type_index].type_name;
        this.new_dic_data.type_code = this.type_list[this.type_index].type_code;
      }
      this.btn_loading = false;
      this.show_add_dic = true;
    },
    // 字典新增
    add_new_dic() {
      var wordNull = Object.keys(this.new_dic_data).some((k) => {
        if (!this.trim(this.new_dic_data[k])) {
          return true;
        }
      });
      // 存在未填写的项目
      if (wordNull) {
        this.$swMessage({
          message: "请按要求填写表单",
          type: "error",
        });
        return;
      }
      // 判断是否只修改了类型名称
      const typeAdd = this.type_list.find((t) => {
        return t.type_code === this.new_dic_data.type_code;
      });
      if (typeAdd) {
        if (typeAdd.type_name !== this.new_dic_data.type_name) {
          this.$swMessage({
            message: "类型代码重复，请重新输入",
            type: "error",
          });
          return;
        }
      }
      const param = this.new_dic_data;
      param.groupId = this.$route.params.id;
      param.scope = "public";
      this.btn_loading = true;
      service
        .post("/v1/dictionary/addDictionary", param)
        .then((res) => {
          this.btn_loading = false;
          if (res.status !== 200) {
            this.$swMessage({
              message: res.msg,
              type: "error",
            });
            return;
          }
          this.$set(this.dic_private, "tableData", []);
          this.show_dic_tab = false;
          if (this.type_list && this.type_list.length > 0) {
            // 新增字典类型成功
            if (
              this.new_dic_data.type_code !==
              this.type_list[this.type_index].type_code
            ) {
              this.type_list.push({
                type_code: this.new_dic_data.type_code,
                type_name: this.new_dic_data.type_name,
              });
            }
            this.get_dic_list(this.type_list[this.type_index], 1);
          } else {
            this.get_dic_type_list();
          }
          this.show_add_dic = !this.show_add_dic;
          this.new_dic_data = {
            type_name: "",
            type_code: "",
            key_code: "",
            value_name: "",
            description: "",
          };
          this.$swMessage({
            message: "新增字典成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.$swMessage({
            message: err,
            type: "error",
          });
        });
    },
    // 私有--切换页面
    private_change_page(page) {
      this.get_dic_list(this.type_list[this.type_index], page);
    },
    // 私有--切换表格数据显示大小
    private_size_change(size) {
      this.limit = size;
      this.get_dic_list(this.type_list[this.type_index], 1);
    },
    // 共有--切换页面
    public_change_page(page) {
      this.get_dic_list(this.type_list[this.type_index], page);
    },
    // 共有--切换表格数据显示大小
    public_size_change(size) {
      this.limit = size;
      this.get_dic_list(this.type_list[this.type_index], 1);
    },
    // 列表操作设置
    private_handle(id, operation) {
      if (this[`${operation}Handle`]) {
        this.btn_loading = false;
        this[`${operation}Handle`](id);
      }
    },
    editHandle(id) {
      this.dic_private.tableData.some((d) => {
        if (d.id === id) {
          this.edit_dic_data = Object.assign({}, d);
          return true;
        }
      });
      this.dic_private.show_edit_panel = true;
    },
    // 字典修改提交
    edit_dic() {
      var wordNull = Object.keys(this.edit_dic_data).some((k) => {
        if (k != "index") {
          if (!this.trim(this.edit_dic_data[k])) {
            return true;
          }
        }
      });
      // 存在未填写的项目
      if (wordNull) {
        this.$swMessage({
          message: "请按要求填写表单",
          type: "error",
        });
        return;
      }
      var param = {
        id: this.edit_dic_data.id,
        name: this.edit_dic_data.type_name,
        name2: this.edit_dic_data.value_name,
        type_code: this.edit_dic_data.type_code,
        key_code: this.edit_dic_data.key_code,
        description: this.edit_dic_data.description,
      };
      this.btn_loading = true;
      service
        .post("/v1/dictionary/updateDictionary", param)
        .then((res) => {
          this.btn_loading = false;
          if (res.status !== 200) {
            this.$swMessage({
              message: res.msg,
              type: "error",
            });
            return;
          }
          this.dic_private.show_edit_panel = !this.dic_private.show_edit_panel;
          this.$set(this.dic_private, "tableData", []);
          this.get_dic_list(this.type_list[this.type_index], 1);
          this.$swMessage({
            message: "编辑字典成功",
            type: "success",
          });
        })
        .catch((err) => {
          this.dic_private.show_edit_panel = !this.dic_private.show_edit_panel;
          this.$set(this.dic_private, "tableData", []);
          this.show_dic_tab = false;
          this.get_dic_list(this.type_list[this.type_index], 1);
          this.$swMessage({
            message: err,
            type: "error",
          });
        });
    },
    // 单个删除
    deleteHandle(id) {
      this.$swConfirm("确定删除字典项吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          var param = {
            // id: Array.isArray(id) ? id : [id]
            id: id,
          };
          service
            .get("/v1/dictionary/delDictionary", { params: param })
            .then((res) => {
              this.$set(this.dic_private, "tableData", []);
              this.show_dic_tab = false;
              this.get_dic_list(this.type_list[this.type_index], 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 批量删除
    delete_dic() {
      if (this.select_arr.length === 0) {
        return;
      }
      var id = this.select_arr.map((i) => {
        return i.id;
      });
      const param = {
        idlist: id,
      };
      console.log(id);
      this.$swConfirm("确定删除字典项吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          service
            .post("/v1/dictionary/batchDelDictionary", param)
            .then((res) => {
              this.$set(this.dic_private, "tableData", []);
              this.show_dic_tab = false;
              this.get_dic_list(this.type_list[this.type_index], 1);
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 选择处理
    select_change(sel) {
      this.select_arr = sel;
    },
    // 获取字典类型列表
    async get_dic_type_list() {
      return new Promise((resolve, reject) => {
        const param = {
          groupId: this.$route.params.id,
          scope: "public",
          // scope: this.dic_tab === '1' ? 'group' : 'public'
        };
        service
          .get("/v1/dictionary/getDictionaryType", { params: param })
          .then((res) => {
            this.type_list = res.data;
            this.type_list_copy = res.data;
            this.show_type_list = true;
            if (this.type_list && this.type_list.length > 0) {
              this.get_dic_list(this.type_list[0], 1);
            } else {
              this.show_search = true;
              this.show_dic_tab = true;
            }
            resolve();
          })
          .catch((err) => {
            this.$swMessage({
              message: err,
              type: "error",
            });
          });
      });
    },
    // 获取字典列表
    async get_dic_list(type, page) {
      this.show_search = true;
      return new Promise((resolve, reject) => {
        const param = {
          type_code: type.type_code,
          page: page,
          limit: this.limit,
        };
        if (this.keyword_list) {
          param.search = this.keyword_list;
        }
        this.loading = true;
        service
          .get("v1/dictionary/getDictionaryValuePage", { params: param })
          .then((res) => {
            if (res.data) {
              this.total_count = res.count;
              if (this.dic_tab === "1") {
                this.$set(this.dic_private, "tableData", res.data);
              } else if (this.dic_tab === "2") {
                this.$set(this.dic_public, "tableData", res.data);
              }
              this.show_dic_tab = true;
              this.loading = false;
            }
            resolve();
          })
          .catch((err) => {
            this.$swMessage({
              message: err,
              type: "error",
            });
          });
      });
    },
    // 搜索
    sea_type(word) {
      word = this.trim(word);
      this.type_list = this.type_list_copy.filter((type) => {
        return type.type_name.includes(word);
      });
      this.keyword_list = "";
      if (this.type_list && this.type_list.length > 0) {
        this.type_index = 0;
        this.get_dic_list(this.type_list[0], 1);
      } else {
        this.$set(this.dic_private, "tableData", []);
        this.$set(this.dic_public, "tableData", []);
      }
      // if(this.ct){
      //   clearTimeout(this.ct)
      // }
      // this.ct = setTimeout((word)=>{
      //   this.type_list = this.type_list_copy.filter(type => {
      //     return type.type_name.includes(word);
      //   })
      // },500)
    },
    // 检测空字符串
    trim(val) {
      if (typeof val === "string" && val.constructor === String) {
        return val.replace(/(^\s*)|(\s*$)/g, "");
      }
      return val;
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@mixin flex-column {
  display: flex;
  flex-direction: column;
}
* {
  padding: 0;
  margin: 0;
}
.el-container {
  height: calc(100vh - 50px);
  overflow: hidden;
}
.el-aside {
  .aside-head {
    text-align: center;
    width: 100%;
    margin: {
      bottom: 11px;
      top: 11px;
    }
    font-size: 18px;
    color: rgba(2, 21, 37, 0.85);
  }
  .btn-labal {
    padding: 15px;
    font-size: 14px;
    color: rgba(39, 56, 70, 1);
    display: flex;
    justify-content: space-between;
  }
  .aside-sea {
    padding: 0 13px;
    margin-bottom: 20px;
  }
  nav {
    width: 100%;
    ul {
      position: relative;
      overflow: auto;
      li {
        padding: 4px 20px;
        margin-bottom: 8px;
        font-size: 14px;
        transition: background 0.2s;
        cursor: pointer;
        border: 1px solid rgba(51, 148, 225, 0);
        &:hover {
          background: #d5ebfd;
        }
      }
      .em-choose {
        padding: 4px 20px;
        margin-bottom: 8px;
        font-size: 14px;
        background: rgba(213, 235, 253, 1);
        border: 1px solid rgba(51, 148, 225, 0.15);
        border-right: 3px solid rgba(51, 148, 225, 1);
      }
    }
  }
}
.el-main {
  overflow: hidden;
  .tdh-left {
    display: flex;
    align-items: center;
    padding: 6px 7px;
    .tdhl-rect-icon {
      margin-right: 4px;
      width: 3px;
      height: 12px;
      background: linear-gradient(
        177deg,
        rgba(97, 193, 190, 1) 0%,
        rgba(51, 148, 225, 1) 100%
      );
    }
    .tdhl-title {
      cursor: pointer;
      margin-right: 4px;
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFangSC;
      font-weight: 400;
      color: rgba(98, 111, 121, 1);
      line-height: 20px;
    }
    .tdhl-arrow-icon {
      margin-right: 4px;
      transform: rotate(-90deg);
      font-size: 12px;
      color: #bec9d2;
    }
    .tdhl-subtitle {
      height: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFangSC;
      font-weight: 400;
      color: rgba(39, 56, 70, 1);
      line-height: 20px;
    }
  }
  .tdh-right {
    cursor: pointer;
    float: right;
    font-size: 14px;
    color: #314250;
    margin-right: 20px;
    margin-top: 10px;
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid #314250;
    }
  }
  .nav-label {
    max-width: calc(100% - 20px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
    border-bottom: 1px solid rgba(225, 228, 230, 1);
    ul {
      display: flex;
      padding-left: 20px;
      li {
        list-style: none;
        cursor: pointer;
        padding: 12px 0;
        margin-right: 60px;
        font-size: 14px;
        color: rgba(98, 111, 121, 1);
      }
    }
  }
  .bd-choose {
    color: rgba(51, 148, 225, 1) !important;
    border-bottom: 2px solid rgba(51, 148, 225, 1);
    font-weight: 500 !important;
  }
  .action-label {
    display: flex;
    justify-content: cneter;
    align-items: center;
    width: calc(100% - 20px);
    padding: 16px 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
    .btn-lab {
      flex: 1;
    }
    .sea-lab {
      width: 300px;
      display: flex;
      justify-content: cneter;
      align-items: center;
      .el-row {
        flex: 1;
      }
      .sw-button {
        margin-left: 8px !important;
      }
    }
  }
  .main-tab {
    max-height: calc(100% - 170px);
    width: calc(100% - 20px);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(39, 56, 70, 0.1);
    overflow: scroll;
  }
}
.el-form {
  padding: 4px 10px !important;
}
</style>
<style lang="scss">
.dic-input {
  .el-input-group__append {
    padding: 0 15px !important;
  }
}
</style>
